import TinyEditor from "./tiny-editor";

export default TinyEditor;